<template>
  <v-container>
    <v-row>
      <v-col>
        <template>
          <v-file-input
            label="File input"
            ref="fileInput"
            accept="text/csv"
            outlined
            dense
            @change="readCSV"
          ></v-file-input>
        </template>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          :items-per-page="5"
          class="elevation-1"
        >
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2">
        <v-btn color="success" @click="save">Сохранить</v-btn>
      </v-col>
      <v-col cols="1">
        <v-btn color="orange" @click="clear">Очистить</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>ID созданных документов</v-card-title>
          <v-card-text v-for="(item, index) in result" :key="index">{{
            item
          }}</v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "App",

  data() {
    return {
      type: "",
      inputFile: "",
      headers: [
        { text: "Структурное подразделение", value: "dep" },
        {
          text: "Должность (специальность, профессия) по штатному расписанию",
          value: "job",
        },
        { text: "Фамилия, имя, отчество", value: "fio" },
        { text: "Табельный номер", value: "num" },
        { text: "Количество календарных дней", value: "days" },
        { text: "Запланированная дата", value: "date" },
      ],
      usersNotB24: {
        "Лавриненко Алексей Александрович": "27", //рук Хомутов
        "Лакетко Николай Иосифович": "27", //рук Хомутов
        "Большев Виктор Валерьевич": "27", //рук Хомутов
        "Нефедченко Андрей Дмитриевич": "27", //рук Хомутов
        "Бойко Наталья Васильевна": "753", //рук Мухачева
        "Баёва Анна Михайловна": "753", //рук Мухачева
        "Волобуева Надежда Владимировна": "753", //рук Мухачева
        "Герт Ольга Борисовна": "753", //рук хомутов
        "Двухжильная Александра Евгеньевна": "753", //рук Мухачева
        "Демьяненко Ирина Анатольевна": "753", //рук Мухачева
        "Пергунова Наталья Вячеславовна": "753", //рук Мухачева
        "Сизикова Елена Николаевна": "753", //рук Мухачева
        "Фёдорова Марина Николаевна": "753", //рук Мухачева
        "Артюхин Сергей Викторович": "13", //рук Губанов
        "Лазуткин Роман Николаевич": "13", //рук Губанов
        "Нифонтов Евгений Николаевич": "13", //рук Губанов
        "Куликов Константин Геннадьевич": "13", //рук Губанов
        "Филипченко Максим Анатольевич": "13", //рук Губанов
        "Кудрявцева Татьяна Юрьевна": "13", //рук Губанов
      },
      items: [],
      file: "",
      users: [],
      result: [],
      url: "https://rusagromarket.bitrix24.ru/rest/223/65r4b8xgsehc1t7l/",
    };
  },
  methods: {
    async getUsers() {
      try {
        let isWhile = true;
        let start = 0;
        while (isWhile) {
          const usersData = await axios.post(this.url + "user.get", {
            start: start,
          });
          this.users.push(...usersData.data.result);
          if (usersData.data.next) {
            start = usersData.data.next;
          } else {
            isWhile = false;
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    readCSV() {
      const file = this.$refs.fileInput.$refs.input.files[0];
      if (file) {
        new Promise(function (resolve, reject) {
          const reader = new FileReader();
          reader.onload = function (evt) {
            resolve(evt.target.result);
          };
          reader.readAsText(file);
          reader.onerror = reject;
        })
          .then(this.processFileContent)
          .catch(function (err) {
            console.log(err);
          });
      }
    },
    processFileContent(data) {
      this.file = data.split("\n");
      //console.log(this.file)
      this.setItems();
    },
    async setItems() {
      try {
        this.type = this.file[0].split("\r")[0];
        this.file.splice(0, 1);
        for (const elem of this.file) {
          if (elem) {
            const elemAray = elem.split(";");
            const dateData = elemAray[5].trim().split(".");
            const date = new Date(dateData[2], dateData[1], dateData[0]);
            const dateAdd = date.getDate() + Number(elemAray[4]);
            const dateOut = new Date(date.setDate(dateAdd));
            console.log();
            const fioData = elemAray[2].trim().split(" ");
            const userSearch = await axios.post(this.url + "user.get", {
              FILTER: {
                NAME_SEARCH: `${fioData[0]} ${fioData[1]}`, //,
              },
            });
            if (userSearch.data.result.length > 0) console.log({ userSearch });
            const item = {
              dep: elemAray[0],
              job: elemAray[1],
              fio: elemAray[2].trim(),
              fioID:
                userSearch.data.result.length > 0
                  ? userSearch.data.result[0].ID
                  : "",
              num: elemAray[3],
              days: elemAray[4],
              date: elemAray[5].trim(),
              dateOut: `${dateOut.getDate()}.${dateOut.getMonth()}.${dateOut.getFullYear()}`,
            };
            this.items.push(item);
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    clear() {
      this.items = [];
      this.file = "";
      this.inputFile = "";
    },
    async save() {
      try {
        //создаем элемент БП согласования отпуска и запускаем процесс
        const date = new Date();

        for (const elem of this.items) {
          console.log({ elem });
          //let boss = "";
         // if (!elem.fioID) boss = this.usersNotB24[elem.fio];
          const method = 'lists.element.add'
          let params = {};
          params = {
            IBLOCK_TYPE_ID: "bitrix_processes",
            IBLOCK_ID: "201",
            ELEMENT_CODE: `${elem.num}/${elem.fio}/${date}`,
            FIELDS: {
              NAME: "Ежегодный отпуск",
              PROPERTY_1805: elem.num, //табельный номер
              PROPERTY_1799: elem.dep, //подразделение
              PROPERTY_1807: elem.days, //кол-во дней
              PROPERTY_1809: elem.date, //дата с
              PROPERTY_1815: elem.dateOut, //дата по
              PROPERTY_1803: elem.fioID, //fio ID
              PROPERTY_1801: elem.job, //должность
              PROPERTY_1813: elem.fio, //fio
              PROPERTY_1811: 733, //тип отгула - отпуск
              PROPERTY_1883: 739, //город 737-мск; 739-нск
            },
          };
          console.log({ params });
          const result = await axios.post(this.url + method, params)
           await axios.post(this.url + 'bizproc.workflow.start', {
             TEMPLATE_ID: 509,
             DOCUMENT_ID: ['lists', 'BizprocDocument', result.data.result],
             PARAMETERS: {}
           })
          this.result.push(result.data.result)
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
  mounted() {
    this.getUsers();
  },
};
</script>
